// lib/utms.ts
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;
type UtmKey = (typeof UTM_KEYS)[number];
export type Utms = Partial<Record<UtmKey, string>>;

export function captureUtmsFromUrl(): void {
  const url = new URL(window.location.href);
  const utms: Utms = {};
  for (const key of UTM_KEYS) {
    const value = url.searchParams.get(key);
    if (value) utms[key] = value;
  }
  if (Object.keys(utms).length > 0) {
    localStorage.setItem("utms", JSON.stringify(utms));
  }
}

export function getStoredUtms(): Utms {
  const stored = localStorage.getItem("utms");
  if (!stored) return {};
  try {
    return JSON.parse(stored) as Utms;
  } catch {
    return {};
  }
}

export function clearStoredUtms(): void {
  localStorage.removeItem("utms");
}
